module.exports = "<div class=\"pp-screen pp-device-orientation-warning\" data-bind=\"visible: visible\">\n\n    <div class=\"pp-screen__background pp-instructions__background\"></div>\n\n    <div class=\"pp-screen__foreground\">\n\n        <div class=\"logo main-menu__logo\">\n            <img class=\"pp-main-menu__edu-logo__image\" src=\"assets/images/intro/logo.png\"/>\n        </div>\n\n        <h2>Turn your device to play</h2>\n\n    </div>\n\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/ts/screens/device-orientation-warning/OrientationWarningScreen.html
// module id = 58
// module chunks = 0